import React from 'react';
import "../../styles/commonComponents/AdminButton.scss";
import { Button } from 'antd';

const AdminButton = ({ name, color, onClick, type }) => {
    return (
        <Button
            className='admin-button'
            color={color}
            variant="outlined"
            onClick={onClick}
            type={type}
        >
            {name}
        </Button>
    );
};

export default AdminButton;